import { render, staticRenderFns } from "./date-template-edit.vue?vue&type=template&id=4004f62f&scoped=true&"
import script from "./date-template-edit.vue?vue&type=script&lang=js&"
export * from "./date-template-edit.vue?vue&type=script&lang=js&"
import style0 from "./date-template-edit.vue?vue&type=style&index=0&id=4004f62f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4004f62f",
  null
  
)

export default component.exports